// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"8a47ae4167cf80ae06f9","655":"7199d73b73f67192a4d1"}[chunkId] + ".js";
};